function buildResponse(error, description) {
  return {
    error: error,
    errorDescription: description
  };
}

function invalidJwt(description) {
  return buildResponse('invalid_token', description);
}

module.exports = {
  buildResponse: buildResponse,
  invalidJwt: invalidJwt
};



//////////////////
// WEBPACK FOOTER
// ./src/helper/error.js
// module id = 21
// module chunks = 0